const transformAll = ({ data }) => {
  return {
    data: data.logs,
    total: data.total,
    actions: [
      { id: 'all', label: 'All' },
      ...data.actions.map((action, id) => {
        return { id: id, label: action };
      })
    ]
  };
};

const transformLocations = branchesRes => {
  return (branchesRes.data?.branches || [])
    .sort((a, b) => a.name.localeCompare(b.name))
    .reduce((acc, { id, name }) => {
      let items = [
        {
          id,
          label: `${name} School`
        }
      ];
      return [...acc, ...items];
    }, []);
};
const transformInstructor = ({ data }) => {
  return (data.totalInstructors?.users || [])
    .sort((a, b) => a.firstName.localeCompare(b.firstName))
    .filter(({ firstName, lastName }) => {
      return firstName.trim().length || lastName.trim().length;
    })
    .reduce((acc, { id, firstName, lastName }) => {
      let items = [
        {
          id,
          label: `${firstName} ${lastName}`
        }
      ];
      return [...acc, ...items];
    }, []);
};

export { transformLocations, transformInstructor, transformAll };
